import React from 'react';

function AboutTeamCardsSection() {
  var team = [
    { name: 'ER. RAJESH SHARMA', title: 'Managing Director', image: '/team1.jpg' },
    { name: 'AMIT VERMA', title: 'Chief Operations Officer', image: '/team2.jpg' },
    { name: 'SANDEEP MEHTA', title: 'Head of Projects', image: '/team3.jpg' },
    { name: 'VIKRAM SINGH RATHOR', title: 'Director - Engineering', image: '/team4.jpg' },
    { name: 'ANKIT AGARWAL', title: 'General Manager - Operations', image: '/team5.jpg' },
    { name: 'PRAKASH JOSHI', title: 'Head - Technical & Quality', image: '/team6.jpg' }
  ];

  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '64px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 32,
      maxWidth: 1200,
      margin: '0 auto'
    },
    card: {
      background: '#FFFFFF',
      borderRadius: 8,
      overflow: 'hidden',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
    },
    imageWrap: {
      width: '100%',
      aspectRatio: '3/4',
      background: '#e8e8e8',
      position: 'relative',
      overflow: 'hidden'
    },
    cardImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    },
    cardBody: {
      padding: '20px 16px 24px',
      textAlign: 'center'
    },
    cardName: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 18,
      lineHeight: 1.3,
      letterSpacing: 0,
      color: '#090909',
      margin: 0,
      textTransform: 'uppercase'
    },
    cardTitle: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: 1.4,
      color: '#E73123',
      margin: '8px 0 0 0'
    }
  };

  return     React.createElement('section', { style: styles.section },
    React.createElement('div', { className: 'about-team-grid', style: styles.grid },
      team.map(function (member, i) {
        return React.createElement('div', {
          key: i,
          className: 'about-team-card',
          style: styles.card
        },
          React.createElement('div', { style: styles.imageWrap },
            React.createElement('img', {
              src: member.image,
              alt: member.name,
              style: styles.cardImage,
              onError: function (e) {
                e.target.style.display = 'none';
              }
            })
          ),
          React.createElement('div', { style: styles.cardBody },
            React.createElement('h4', { style: styles.cardName }, member.name),
            React.createElement('p', { style: styles.cardTitle }, member.title)
          )
        );
      })
    )
  );
}

export default AboutTeamCardsSection;
